module.exports = __webpack_public_path__ + "media/images/default_favicon-b139eafbdafba935a4f18bdf18efe71f.png";